export default class RequestException extends Error {
  origin!: boolean;
  constructor(message: string, origin: boolean) {
    super(message);
    this.origin = origin;
  }
}
